/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import useStore from '@store/index';
import { Navigate } from 'react-router';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */

type PublicRouteProps = {
	children: React.ReactNode;
};

/* -------------------------------------------------------------------------- */
/*                               Public Router                                */
/* -------------------------------------------------------------------------- */
export const PublicRoute: React.FC<PublicRouteProps> = ({
	children,
}: PublicRouteProps) => {
	const { getUser } = useStore();
	const user = getUser();
	if (user) {
		return <Navigate to="/" />;
	}

	return children;
};

export default PublicRoute;
